import React, { useEffect, useRef, useState } from "react";
import style from "../../assets/css/header.module.scss";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import {
  Avatar,
  Button,
  Drawer,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Skeleton,
} from "@mui/material";
import GlobalLogo from "../global-fields/GlobalLogo";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logout } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthState, setAuthData } from "../../store/authSlice";
import { removeCookies } from "../../constants/helper";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import ColorTheme from "../../assets/css/_themes-vars.module.scss";
// import {isTablet } from "react-device-detect";
import { persistor } from "../../store/store";
import { selectUiState, setUiData } from "../../store/uiSlice";
import { selectDataStoreState } from "../../store/dataSlice";
import GlobalLogoLLC from "../global-fields/GlobalLogoLLC";
import GlobalLogoLLOYDS from "../global-fields/GlobalLogoLLOYDS";

const MenuItemsAfterLogin = [
  {
    id: 1,
    name: "Home",
    url: "/",
  },
  {
    id: 2,
    name: "Dashboard",
    url: "/dashboard",
  },
  {
    id: 1,
    name: "Jewelers Block",
    url: "/jewelers-block",
  },
  {
    id: 2,
    name: "About Us",
    url: "/about-us",
  },
  //  {
  //   id: 3,
  //   name: "Jewelers Block Policy",
  //   url: "/jewelers-block-policy",
  // },
  {
    id: 4,
    name: "Contact Us",
    url: "/contact-us",
  },
];

const MenuItems = [
  {
    id: 1,
    name: "Jewelers Block",
    url: "/jewelers-block",
  },
  {
    id: 2,
    name: "About Us",
    url: "/about-us",
  },
  // {
  //   id: 3,
  //   name: "Jewelers Block Policy",
  //   url: "/jewelers-block-policy",
  // },
  {
    id: 4,
    name: "Contact Us",
    url: "/contact-us",
  },
];

export { MenuItems, MenuItemsAfterLogin };

function Header() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dynamicHeaderHeight } = useSelector(selectUiState);
  const { proposalStep, proposal_id, jewelers_block_type } = useSelector(selectDataStoreState);

  const { user } = useSelector(selectAuthState);
  const [isScrollValueHeaderHeight, setIsScrollValueHeaderHeight] =
    useState(false);
  // console.log("HEADER USER", isLogin, user);

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuClick = () => {
    setMobileOpen(false);
  };
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    // navigate("/profile");
  };
  const handleProfile = () => {
    setAnchorEl(null);
    navigate("/profile");
  };

  const hideHeaderPaths = ["/verification", "/reset-password"];
  // let shouldHideHeader = hideHeaderPaths.some((path) =>
  //   location?.pathname.includes(path)
  // );
  // console.log("location", location);
  const [shouldHideHeader, setShouldHideHeader] = useState(
    hideHeaderPaths.some((path) => location?.pathname.includes(path))
  );
  const showRiskhHeader = location?.pathname === "/";

  // const handleLogout = () => {
  //   GlobalNotificationPopup({ type: "success", message: "logged out." });
  //   dispatch({ type: "LOGOUT" });
  //   persistor.purge();
  //   removeCookies("isLogin");
  //   setAnchorEl(null);
  //   navigate("/");
  // };
  const handleLogout = () => {
    GlobalNotificationPopup({ type: "success", message: "Logged out." });
    dispatch({ type: "LOGOUT" });
    persistor.purge();
    removeCookies("isLogin");
    setAnchorEl(null);
    // // Navigate and force re-render instead of full reload
    // navigate("/", { replace: true });

    navigate("/");

    // Correct way to reload the page
    window.location.reload();
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrollValueHeaderHeight(window.scrollY > 15);
    };
    if (
      location.pathname !== "/diamond-form" &&
      location.pathname !== "/new-proposal" &&
      proposal_id === null
    ) {
      dispatch(
        setAuthData({
          selectedClient: null,
        })
      );
    }
    setShouldHideHeader(
      hideHeaderPaths.some((path) => location?.pathname.includes(path))
    );
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);

  const dynamicHeightDiv = useRef(null);
  const headerRefDesktop = useRef(null);
  const headerRef1 = useRef(null);
  const headerRef2 = useRef(null);
  // const headerRefMobile = useRef(null);
  const [skeletonVal, setSkeletonVal] = useState(true);

  useEffect(() => {
    // if (!isMobile) {
    // Check if headerRefDesktop has been assigned to the div
    if ((headerRef1.current && headerRef2.current) || headerRef2.current) {
      // console.log("headerRef1.current.offsetHeight", headerRef1.current.offsetHeight, headerRef2.current.offsetHeight, headerRef1.current.offsetHeight + headerRef2.current.offsetHeight);

      if (dynamicHeightDiv.current) {
        // dynamicHeightDiv.current.style.height = `125px`; // Set the height to dynamicHeightDiv
        dynamicHeightDiv.current.style.height = `${(headerRef1?.current?.offsetHeight || 0) + (headerRef2?.current?.offsetHeight || 0)}px`;
        let heightVal =
          (headerRef1?.current?.offsetHeight || 0) +
          (headerRef2?.current?.offsetHeight || 0);
        // console.log("salman", (headerRef1?.current?.offsetHeight || 0), (headerRef2?.current?.offsetHeight || 0), (headerRef1?.current?.offsetHeight || 0) + (headerRef2?.current?.offsetHeight || 0), dynamicHeightDiv)
        dispatch(
          setUiData({
            dynamicHeaderHeight: heightVal,
          })
        );
        setTimeout(() => {
          setSkeletonVal(false);
        }, 300);
        // Set the height to dynamicHeightDiv
      }
    }
    // } else {
    //   // Check if headerRefMobile has been assigned to the div
    //   if (headerRefMobile.current) {
    //     if (dynamicHeightDiv.current) {
    //       dynamicHeightDiv.current.style.height = `${headerRefMobile.current.offsetHeight}px`; // Set the height to dynamicHeightDiv
    //     }
    //   }
    // }
  }, [location, shouldHideHeader, headerRef1.current, headerRef2.current]);

  const isDesktop = window.innerWidth > 1025;
  const isMobile = window.innerWidth < 1025;

  const displayLogoOld = () => {
    const route = location.pathname;
    if (route === "/new-proposal" && jewelers_block_type == 0) {
      return <GlobalLogoLLC logoClass={style.headerMainLogoLLC} />;
    } if (route === "/new-proposal" && jewelers_block_type == 1) {
      return <>
        <div className={"LodsLogoMain"}>
          <GlobalLogo logoClass={style.headerMainLogo} />
          <GlobalLogoLLOYDS logoClass={style.headerLLOYDSLogo} />
        </div>
      </>;
    } else {
      return <GlobalLogo logoClass={style.headerMainLogo} />;
    }
  };
  const displayLogo = () => {
    const route = location.pathname;
    if (route === "/new-proposal" && jewelers_block_type == 0) {
      return <GlobalLogoLLC logoClass={style.headerMainLogoLLC} />;
    } else if (jewelers_block_type == 1) {
      return <>
        <div className={"LodsLogoMain"}>
          <GlobalLogo logoClass={style.headerMainLogo} />
          <GlobalLogoLLOYDS logoClass={style.headerLLOYDSLogo} />
        </div>
      </>;
    } else {
      return <>
        <div className={"LodsLogoMain"}>
          <GlobalLogo logoClass={style.headerMainLogo} />
          <GlobalLogoLLOYDS logoClass={style.headerLLOYDSLogo} />
        </div>
      </>;
    }
  };

  // const displayLogo = () => {
  //   const route = location.pathname;
  //   if (route === "/new-proposal" && jewelers_block_type == 0) {
  //     return <GlobalLogoLLC logoClass={style.headerMainLogoLLC} />;
  //   } else {
  //     return <GlobalLogo logoClass={style.headerMainLogo} />;
  //   }
  // };

  return (
    <>
      {shouldHideHeader ? null : (
        <>
          <div
            className={
              showRiskhHeader && isScrollValueHeaderHeight
                ? style.headerMain + " " + "header-sticky-top"
                : style.headerMain
            }
            ref={headerRefDesktop}
          >
            {/* {showRiskhHeader ? ( */}
            <div
              ref={headerRef1}
              className={
                isScrollValueHeaderHeight
                  ? style.strapwraper + " " + "hideTopheader"
                  : style.strapwraper
              }
            >
              <div className={style.headerContainer}>
                <div className={style.strapContent}>
                  <div>
                    <Link
                      to="#"
                      onClick={(e) => {
                        window.location.href = `tel:+12124895300`;
                      }}
                    >
                      <FaPhoneAlt /> +1 (212)-489-5300
                    </Link>
                  </div>
                  <div className={style.WeUnder}>
                    <p> We Understand Your Risk </p>
                  </div>
                  <div>
                    <Link
                      to="#"
                      onClick={(e) => {
                        window.location.href = `mailto:office@aibnewyork.com`;
                      }}
                    >
                      <IoMail /> office@aibnewyork.com
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* ) : null} */}

            <div ref={headerRef2}>
              {skeletonVal ? (
                <Skeleton
                  height={isMobile ? 72 : 82}
                  variant=""
                  style={{ backgroundColor: "white" }}
                />
              ) : (
                <div className={style.headerContainer}>
                  <div className={style.headerMenuBar}>
                    <div className={style.logoAndBar}>
                      <div className={style.mobileMenu}>
                        <IconButton
                          onClick={handleDrawerToggle}
                          aria-label="menu-icon"
                        >
                          <MenuIcon />
                        </IconButton>
                      </div>

                      <Link to="/">
                        {/* <GlobalLogo logoClass={style.headerMainLogo} /> */}
                        {displayLogo()}
                        {/* <div className={"LodsLogoMain"}>{displayLogo()}
                          <GlobalLogoLLOYDS logoClass={style.headerLLOYDSLogo} />
                        </div> */}
                      </Link>
                    </div>

                    {/* Mobile and Tablet Logo  */}
                    {isMobile ? (
                      <div className={style.MenuList}>
                        <Link to="/">
                          {/* <GlobalLogo logoClass={style.headerMainLogo} /> */}
                          {displayLogo()}
                          {/* <div className={"LodsLogoMain"}>{displayLogo()}
                            <GlobalLogoLLOYDS logoClass={style.headerLLOYDSLogo} />
                          </div> */}
                        </Link>
                      </div>
                    ) : null}

                    {/*Desktop Logo  */}
                    <div className={style.MenuList}>
                      {/* {isDesktop ? <Link to="/">
                        <GlobalLogo logoClass={style.headerMainLogo} />
                        desktop
                      </Link> : null} */}

                      {/* {isDesktop ? (
                        <Link to="/">
                          {displayLogo()}
                        </Link>
                      ) : null} */}

                      {!shouldHideHeader ? (
                        <ul className={style.desktopMenu}>
                          {user?.id
                            ? MenuItemsAfterLogin.map((mi, mid) => {
                              return (
                                <li key={mid}>
                                  <Link to={mi?.url}>{mi?.name}</Link>
                                </li>
                              );
                            })
                            : MenuItems.map((mi, mid) => {
                              return (
                                <li key={mid}>
                                  <Link to={mi?.url}>{mi?.name}</Link>
                                </li>
                              );
                            })}
                        </ul>
                      ) : null}

                      <div className={style.profileCircle}>
                        {user?.id ? (
                          <>
                            <IconButton
                              aria-label="avtar-img"
                              onClick={handleClick}
                              size="small"
                              sx={{ ml: 1 }}
                              aria-controls={open ? "account-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                            >
                              <Avatar
                                sx={{
                                  width: 40,
                                  height: 40,
                                  background: ColorTheme?.SuryaPrimary,
                                }}
                                src={user?.image ? user?.image : ""}
                              >
                                {!user?.image
                                  ? user?.first_name?.charAt(0)?.toUpperCase() +
                                  user?.last_name?.charAt(0)?.toUpperCase()
                                  : null}
                              </Avatar>
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl}
                              id="account-menu"
                              open={open}
                              onClose={handleClose}
                              onClick={handleClose}
                              slotProps={{
                                paper: {
                                  elevation: 0,
                                  sx: {
                                    overflow: "visible",
                                    filter:
                                      "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                    mt: 1.5,
                                    "& .MuiAvatar-root": {
                                      width: 32,
                                      height: 32,
                                      ml: -0.5,
                                      mr: 1,
                                    },
                                    "&::before": {
                                      content: '""',
                                      display: "block",
                                      position: "absolute",
                                      top: 0,
                                      right: 14,
                                      width: 10,
                                      height: 10,
                                      bgcolor: "background.paper",
                                      transform:
                                        "translateY(-50%) rotate(45deg)",
                                      zIndex: 0,
                                    },
                                  },
                                },
                              }}
                              transformOrigin={{
                                horizontal: "right",
                                vertical: "top",
                              }}
                              anchorOrigin={{
                                horizontal: "right",
                                vertical: "bottom",
                              }}
                            >
                              <MenuItem onClick={handleProfile}>
                                <ListItemIcon>
                                  <PersonIcon fontSize="small" />
                                </ListItemIcon>
                                Profile
                              </MenuItem>
                              <MenuItem onClick={handleLogout}>
                                <ListItemIcon>
                                  <Logout fontSize="small" />
                                </ListItemIcon>
                                Logout
                              </MenuItem>
                            </Menu>
                          </>
                        ) : (
                          <Link to="/login">
                            <Button
                              variant="contained"
                              className={style.loginBtn}
                              type="button"
                            >
                              Login
                            </Button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Mobile menu drawer */}
            <Drawer open={mobileOpen} onClose={handleDrawerToggle}>
              <div className={style.drawerMenuMain}>
                {/* <Link to="/" onClick={handleMenuClick}>
                  <GlobalLogo logoClass={style.headerMainLogo} />
                  {displayLogo()}
                </Link> */}
                {!shouldHideHeader ? (
                  <ul className={style.desktopMenu}>
                    <li style={{
                      background: "#004F71",
                      color: "white",
                      padding: "9px 15px",
                      textAlign: "center",
                      fontSize: "18px",
                    }}>
                      <span> Menu </span>
                    </li>
                    {(user?.id ? MenuItemsAfterLogin : MenuItems).map(
                      (mi, mid) => (
                        <li key={mid}>
                          <Link to={mi.url} onClick={handleMenuClick}>
                            {mi.name}
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                ) : null}
              </div>
            </Drawer>
            {/* Mobile menu drawer */}
          </div>

          <div className="test" ref={dynamicHeightDiv}></div>
        </>
      )}
    </>
  );
}

export default Header;
